import { type Updater, useQuery } from '@tanstack/react-query'
import storage from '../Storage'
import queryClient from '../queryClient'

const WHATS_NEW_VERSION_QUERY_OPTIONS_KEY = ['LAST_SHOW_WHATS_NEW_VERSION']
export function setLastShowWhatsNewVersion(value: string | null) {
	queryClient.setQueryData(WHATS_NEW_VERSION_QUERY_OPTIONS_KEY, value)
	storage.lastShowWhatsNewVersion = value
}
export function useLastShowWhatsNewVersion() {
	const { data } = useQuery<string | null>({
		queryKey: WHATS_NEW_VERSION_QUERY_OPTIONS_KEY,
		initialData: storage.lastShowWhatsNewVersion,
	})

	return [data, setLastShowWhatsNewVersion] as const
}

export const IS_YELLOW_MEMBER_RIGHTS_MODAL_SHOW_QUERY_OPTIONS_KEY = [
	'IS_YELLOW_MEMBER_RIGHTS_MODAL_SHOW',
]
export function setIsYellowMemberRightsModalShow(updater: Updater<boolean, boolean>) {
	return queryClient.setQueryData<boolean>(
		IS_YELLOW_MEMBER_RIGHTS_MODAL_SHOW_QUERY_OPTIONS_KEY,
		updater as Updater<boolean | undefined, boolean | undefined>
	)
}
export function useIsYellowMemberRightsModalShow() {
	const { data } = useQuery<boolean>({
		queryKey: IS_YELLOW_MEMBER_RIGHTS_MODAL_SHOW_QUERY_OPTIONS_KEY,
		initialData: false,
	})
	return [data, setIsYellowMemberRightsModalShow] as const
}
